<template>

  <fieldset class="border p-4 mt-4"
    :class="[error ? 'border-red-500' : 'border-gray-300']">
    <div class="text-base/7 font-semibold text-gray-900 items-center">
      <a v-if="agreement.document_url" :href="agreement.document_url" target="_blank"
        class="flex items-center text-gray-900 no-underline hover:underline">
        <div class="flex-0">
          <DocumentIcon class="w-5 h-5 mr-2" />
        </div>
        <span>{{ agreement?.title }}</span>
      </a>
      <span v-else>{{ agreement?.title }}</span>
    </div>
    <p v-if="agreement?.content" class="text-sm mt-2 max-h-48 overflow-y-auto" v-html="agreement?.content"></p>

    <div class="flex items-center space-x-4 mt-4">
      <div class="flex h-6 shrink-0 items-center">
        <div v-if="agreement.acceptance == 'checkbox'">
          <div class="flex items-center group">
            <input
              :id="'agreement-' + agreement.id"
              aria-describedby="agreement-description"
              name="agreement"
              type="checkbox"
              :checked="modelValue === 'TAK'"
              @change="handleCheckboxChange"
              value="TAK"
              class="h-5 w-5 text-primary-500 focus:ring-primary-500 border-gray-300 rounded mr-3"
            />
            <label :for="'agreement-' + agreement.id"
              class="font-medium hover:underline cursor-pointer text-primary-500">Akceptuję</label>
          </div>
        </div>
       
        <div v-else-if="agreement.acceptance == 'dropdown'" class="flex justify-end w-full">
          <select 
            :id="'agreement-' + agreement.id" 
            aria-describedby="agreement-description" 
            name="agreement"
            class="px-8 py-2" 
            :value="modelValue"
            @change="handleDropdownChange">
            <option value="" selected>brak&nbsp;</option>
            <option value="TAK">tak</option>  
            <option value="NIE">nie</option>
          </select> 
        </div>
      </div>
    </div>
    <p v-if="error" class="text-red-500 text-sm mt-2">{{ error }}</p>
  </fieldset>
</template>

<script>
import { DocumentIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'AgreementBox',
  components: {
    DocumentIcon
  },
  props: {
    agreement: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Boolean],
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleCheckboxChange(event) {
      const value = event.target.checked ? 'TAK' : '';
      this.$emit('update:modelValue', value);
    },
    handleDropdownChange(event) {
      this.$emit('update:modelValue', event.target.value);
    }
  }
};
</script>
